(function() {
    "use strict";

    angular.module('app').component('habilLabelWithHelp', {
        templateUrl: '@/labels/label-with-help.html',
        transclude: true,
        bindings: {
            for: '@',
            info: '@',
            isRequired: '@'
        },
        controllerAs: 'vm'
    });

})();